import { Box, Typography } from "@mui/material";
import hero from "./loginHero.png";
import { loginColors, loginType } from "./loginTheme";

const pills = ["Inventory", "Approvals", "Suppliers", "Reports"];

const LoginHero = () => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      overflow: "hidden",
      bgcolor: loginColors.page,
    }}
  >
    <Box
      component="img"
      src={hero}
      alt=""
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        objectPosition: "center",
        display: "block",
      }}
    />
    <Box
      aria-hidden="true"
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(to top, rgba(15, 69, 101, 0.48) 0%, rgba(15, 69, 101, 0.22) 38%, rgba(15, 69, 101, 0.18) 100%)",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        display: { xs: "none", md: "block" },
        left: 0,
        right: "18%",
        bottom: 0,
        px: { md: 5, lg: 6 },
        pb: { md: 5, lg: 6 },
        color: "#fff",
        fontFamily: loginType.fontFamily,
      }}
    >
      <Typography
        component="h2"
        sx={{
          ...loginType.systemTitle,
          fontFamily: "inherit",
          color: "#fff",
          mb: 1,
        }}
      >
        Procurement Operations
      </Typography>
      <Typography
        sx={{
          ...loginType.supporting,
          fontFamily: "inherit",
          color: "rgba(255, 255, 255, 0.9)",
          maxWidth: 460,
          mb: 2.5,
        }}
      >
        Manage purchasing, stock, suppliers and approvals through one centralized workspace.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
        {pills.map((label) => (
          <Box
            key={label}
            component="span"
            sx={{
              px: 1.25,
              py: 0.4,
              borderRadius: 99,
              fontSize: 12,
              fontWeight: 500,
              lineHeight: 1.3,
              color: "rgba(255, 255, 255, 0.88)",
              bgcolor: "rgba(255, 255, 255, 0.08)",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              backdropFilter: "blur(8px)",
            }}
          >
            {label}
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
);

export default LoginHero;
